import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'

import reducers from './reducers'
import { verifyAuth } from './actions'

export default (initialState = {}) => {
  let middleware = applyMiddleware(thunk)

  if (process.env.NODE_ENV !== 'production') {
    const devToolsExtension = window.devToolsExtension
    if (typeof devToolsExtension === 'function') {
      middleware = compose(middleware, devToolsExtension())
    }
  }

  const store = createStore(reducers, initialState, middleware)

  store.dispatch(verifyAuth())

  return store
}



// WEBPACK FOOTER //
// ./src/store.js